import {
  setToken,
  getToken,
  setUserAvatar,
  getUserAvatar,
  setFillMore,
  getFillMore,
  setPaymentInfo,
  getPaymentInfo
} from '@/libs/util'
import MentorAvatar from '@/assets/images/home/mentor-avatar.svg'
import { login, logout, getUserRole } from '@/api/talents'
export default {
  state: {
    token: getToken(),
    userRole: '',
    userAvatar: getUserAvatar(),
    isFillMore: getFillMore(),
    isPaymentInfo: getPaymentInfo()
  },
  mutations: {
    // token
    setToken (state, token) {
      state.token = token
      setToken(token)
    },
    // 设置头像
    setUserAvatar (state, avatar) {
      state.userAvatar = avatar
      setUserAvatar(avatar)
    },
    // 基本信息是否填完
    setFillMore (state, boer) {
      state.isFillMore = !!boer
      setFillMore(!!boer)
    },
    // payment是否填写完成
    setPaymentInfo (state, boer) {
      state.isPaymentInfo = !!boer
      setPaymentInfo(!!boer)
    },
    // 设置用户角色
    setUserRole (state, role) {
      state.userRole = role
    }
  },
  actions: {
    handleLogin ({ commit }, data) {
      return new Promise((resolve, reject) => {
        login(data)
          .then(res => {
            const data = res.data.result
            commit('setToken', data.accessToken)
            commit('setUserAvatar', data.userInfo.avaurl || MentorAvatar)
            commit('setFillMore', data.userInfo.isFillMore)
            commit('setPaymentInfo', data.userInfo.isPaymentInfo)
            resolve(data)
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    // 退出登录
    handleLogOut ({ state, commit }) {
      return new Promise((resolve, reject) => {
        logout({})
          .then(() => {
            commit('setToken', '')
            commit('setUserAvatar', '')
            commit('setFillMore', '')
            commit('setPaymentInfo', '')
            resolve()
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    // 获取用户角色
    getUserRole ({ state, commit }) {
      return new Promise((resolve, reject) => {
        getUserRole({})
          .then(res => {
            let mentorRole =
              res.data && res.data.userInfo && res.data.userInfo.mentorRole
            commit('setUserRole', mentorRole)
            resolve(res.data.userInfo)
          })
          .catch(err => {
            reject(err)
          })
      })
    }
  }
}
